export const SmokingOptions = [
    { displayName: "Smoker", id: "smoker" },
    { displayName: "Non-smoker", id: "nonsmoker" }
]